import Upload from "./Upload";
import Wrapper from "./Wrapper";

export default {
  Upload,
  Wrapper
};
